import React, { useState } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { API_BASE } from "../api/apiConfig";

const Profile = () => {
  // State for active tab
  const [activeTab, setActiveTab] = useState("community");
  // Toggles for notifications
  const [toggles, setToggles] = useState({
    email: true,
    push: false,
    sms: true,
    marketing: false,
  });
  // Privacy settings
  const [privacy, setPrivacy] = useState({
    profileVisible: true,
    showEmail: false,
    showPhone: false,
  });

  // Toggle functions
  const toggleSwitch = (setter, key) => {
    setter((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const togglePrivacy = (key) => {
    setPrivacy((prev) => ({ ...prev, [key]: !prev[key] }));
  };




  const tabIcons = {
  community: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users w-4 h-4"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
  ),
  trips: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plane w-4 h-4"><path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"></path></svg>

  ),
  meetups: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar w-4 h-4"><rect width="18" height="18" x="3" y="4" rx="2" ry="2"></rect><line x1="16" x2="16" y1="2" y2="6"></line><line x1="8" x2="8" y1="2" y2="6"></line><line x1="3" x2="21" y1="10" y2="10"></line></svg>
  ),
  settings: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-settings w-4 h-4"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path><circle cx="12" cy="12" r="3"></circle></svg>
  ),
};


  // Reusable ToggleRow component
  const ToggleRow = ({ title, desc, value, onToggle }) => (
    <div>
      <div className="flex items-center justify-between py-2">
        <div>
          <p className="text-sm font-medium text-gray-700">{title}</p>
          <p className="text-xs text-gray-500">{desc}</p>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={value}
          onClick={onToggle}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
            value ? "bg-primary" : "bg-gray-300"
          }`}
        >
          <span
            className={`inline-block h-5 w-5 rounded-full bg-white shadow-md transform transition-transform duration-300 ${
              value ? "translate-x-5" : "translate-x-0"
            }`}
          />
        </button>
      </div>
      <div className="h-px w-full bg-gray-200 my-2" />
    </div>
  );

  return (
    <>
      <Header />

      <main className="flex-1">
        <div className="max-w-7xl mx-auto px-4 py-4 mb-12 lg:py-10">
          <div className="hidden sm:block">
              <div className="min-h-screen bg-gradient-to-br from-green-50/30 via-white to-blue-50/20">
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-10">
                  {/* LEFT PROFILE */}
                  <div className="lg:col-span-1">
                    <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg sticky top-8">
                      <div className="p-8">
                        <div className="text-center mb-8">
                          <span className="relative flex shrink-0 overflow-hidden rounded-full w-24 h-24 mx-auto mb-6 border-4 border-primary/20">
                            <img
                              className="aspect-square h-full w-full"
                              alt="Sarah Chen"
                              src="/assets/images/member-profile-1.png"
                            />
                          </span>
                          <h1 className="text-xl font-bold text-gray-900 mb-2">Sarah Chen</h1>
                          <p className="text-sm text-gray-600 mb-3">@sarahexplores</p>
                          <p className="text-sm text-gray-500 mb-6">San Francisco, CA</p>
                          <div className="grid grid-cols-2 gap-4 mb-8">
                            <div className="text-center">
                              <div className="text-lg font-bold text-primary">24</div>
                              <div className="text-xs text-gray-500">Trips</div>
                            </div>
                            <div className="text-center">
                              <div className="text-lg font-bold text-primary">12</div>
                              <div className="text-xs text-gray-500">Countries</div>
                            </div>
                            <div className="text-center">
                              <div className="text-lg font-bold text-primary">1247</div>
                              <div className="text-xs text-gray-500">Followers</div>
                            </div>
                            <div className="text-center">
                              <div className="text-lg font-bold text-primary">892</div>
                              <div className="text-xs text-gray-500">Following</div>
                            </div>
                          </div>
                          <p className="text-sm text-gray-600 mb-8 text-left leading-relaxed">
                            Adventure seeker and culture enthusiast. Love discovering hidden gems
                            and sharing travel stories with fellow wanderers.
                          </p>
                          <div className="flex flex-wrap gap-2 mb-8">
                            <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 bg-primary/10 text-primary text-xs">
                              Explorer
                            </div>
                            <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 bg-primary/10 text-primary text-xs">
                              Culture Lover
                            </div>
                            <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 bg-primary/10 text-primary text-xs">
                              Foodie
                            </div>
                            <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 bg-primary/10 text-primary text-xs">
                              Solo Traveler
                            </div>
                          </div>
                          <div className="space-y-3">
                            <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 text-primary hover:bg-primary/10 bg-transparent">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-pen-square w-4 h-4 mr-2"
                              >
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
                              </svg>
                              Edit Profile
                            </button>
                            <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-red-300 text-red-600 hover:bg-red-50 bg-transparent">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-log-out w-4 h-4 mr-2"
                              >
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                <polyline points="16 17 21 12 16 7" />
                                <line x1={21} x2={9} y1={12} y2={12} />
                              </svg>
                              Logout
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>



                  {/* RIGHT CONTENT */}
                  <div className="lg:col-span-3">
                    {/* TABS */}
                    <div className="grid grid-cols-4 bg-gray-100 rounded-xl p-1 mb-6">
                      {["community", "trips", "meetups", "settings"].map((tab) => (
                        <button
                          key={tab}
                          onClick={() => setActiveTab(tab)}
                          className={`justify-center whitespace-nowrap px-3 font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 flex items-center gap-2 text-sm data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:shadow-sm rounded-lg transition-all duration-200 py-3  ${
                            activeTab === tab
                              ? "bg-white shadow text-primary"
                              : "text-gray-500"
                          }`}
                        >
                          {tabIcons[tab]}
                          <span>
                            {tab.charAt(0).toUpperCase() + tab.slice(1)}
                          </span>
                        </button>
                      ))}
                    </div>


                    {/* TAB CONTENT */}
                    {activeTab === "community" && (
                      <>
                          <div>
                              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                                My Communities
                              </h2>
                              <p className="text-gray-600">
                                Communities you're part of and actively participating in
                              </p>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                              <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                                <div className="p-8">
                                  <div className="flex items-start gap-4 mb-6">
                                    <span className="relative flex shrink-0 overflow-hidden rounded-full w-16 h-16 border-2 border-primary/20">
                                      <img
                                        className="aspect-square h-full w-full"
                                        alt="Solo Female Travelers"
                                        src="/assets/images/solo-mountain-vista.png"
                                      />
                                    </span>
                                    <div className="flex-1">
                                      <h3 className="font-bold text-lg text-gray-900 mb-2">
                                        Solo Female Travelers
                                      </h3>
                                      <p className="text-sm text-gray-600 mb-3">
                                        A supportive community for women traveling alone
                                      </p>
                                      <div className="flex items-center gap-4 text-xs text-gray-500">
                                        <span className="flex items-center gap-1">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-users w-3 h-3"
                                          >
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                            <circle cx={9} cy={7} r={4} />
                                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                          </svg>
                                          15420 members
                                        </span>
                                        <span className="flex items-center gap-1">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-map-pin w-3 h-3"
                                          >
                                            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                            <circle cx={12} cy={10} r={3} />
                                          </svg>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary">
                                    View Community
                                  </button>
                                </div>
                              </div>
                              <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                                <div className="p-8">
                                  <div className="flex items-start gap-4 mb-6">
                                    <span className="relative flex shrink-0 overflow-hidden rounded-full w-16 h-16 border-2 border-primary/20">
                                      <img
                                        className="aspect-square h-full w-full"
                                        alt="Asian Food Explorers"
                                        src="/assets/images/bustling-asian-street-food.png"
                                      />
                                    </span>
                                    <div className="flex-1">
                                      <h3 className="font-bold text-lg text-gray-900 mb-2">
                                        Asian Food Explorers
                                      </h3>
                                      <p className="text-sm text-gray-600 mb-3">
                                        Discovering authentic Asian cuisine around the world
                                      </p>
                                      <div className="flex items-center gap-4 text-xs text-gray-500">
                                        <span className="flex items-center gap-1">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-users w-3 h-3"
                                          >
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                            <circle cx={9} cy={7} r={4} />
                                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                          </svg>
                                          8934 members
                                        </span>
                                        <span className="flex items-center gap-1">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-map-pin w-3 h-3"
                                          >
                                            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                            <circle cx={12} cy={10} r={3} />
                                          </svg>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary">
                                    View Community
                                  </button>
                                </div>
                              </div>
                              <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                                <div className="p-8">
                                  <div className="flex items-start gap-4 mb-6">
                                    <span className="relative flex shrink-0 overflow-hidden rounded-full w-16 h-16 border-2 border-primary/20">
                                      <img
                                        className="aspect-square h-full w-full"
                                        alt="SF Bay Area Travelers"
                                        src="/assets/images/coastal-mountain-vista.png"
                                      />
                                    </span>
                                    <div className="flex-1">
                                      <h3 className="font-bold text-lg text-gray-900 mb-2">
                                        SF Bay Area Travelers
                                      </h3>
                                      <p className="text-sm text-gray-600 mb-3">
                                        Local travelers from San Francisco Bay Area
                                      </p>
                                      <div className="flex items-center gap-4 text-xs text-gray-500">
                                        <span className="flex items-center gap-1">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-users w-3 h-3"
                                          >
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                            <circle cx={9} cy={7} r={4} />
                                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                          </svg>
                                          2156 members
                                        </span>
                                        <span className="flex items-center gap-1">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-map-pin w-3 h-3"
                                          >
                                            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                            <circle cx={12} cy={10} r={3} />
                                          </svg>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary">
                                    View Community
                                  </button>
                                </div>
                              </div>
                              <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                                <div className="p-8">
                                  <div className="flex items-start gap-4 mb-6">
                                    <span className="relative flex shrink-0 overflow-hidden rounded-full w-16 h-16 border-2 border-primary/20">
                                      <img
                                        className="aspect-square h-full w-full"
                                        alt="Photography Enthusiasts"
                                        src="/assets/images/serene-beach-read.png"
                                      />
                                    </span>
                                    <div className="flex-1">
                                      <h3 className="font-bold text-lg text-gray-900 mb-2">
                                        Photography Enthusiasts
                                      </h3>
                                      <p className="text-sm text-gray-600 mb-3">
                                        Capturing the world through our lenses
                                      </p>
                                      <div className="flex items-center gap-4 text-xs text-gray-500">
                                        <span className="flex items-center gap-1">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-users w-3 h-3"
                                          >
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                            <circle cx={9} cy={7} r={4} />
                                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                          </svg>
                                          12678 members
                                        </span>
                                        <span className="flex items-center gap-1">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-map-pin w-3 h-3"
                                          >
                                            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                            <circle cx={12} cy={10} r={3} />
                                          </svg>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary">
                                    View Community
                                  </button>
                                </div>
                              </div>
                            </div>
                      </>
                    )}

                    {activeTab === "trips" && (
                      <div
                        className="ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-8 mt-0"
                        >
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">
                            My Travel Bookings
                          </h2>
                          <p className="text-gray-600">Manage your booked trips and travel history</p>
                        </div>
                        <div className="flex gap-3 mb-6">
                          <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 border-primary/30 text-primary hover:bg-primary/10 bg-transparent">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-search w-4 h-4 mr-2"
                            >
                              <circle cx={11} cy={11} r={8} />
                              <path d="m21 21-4.3-4.3" />
                            </svg>
                            Search Trips
                          </button>
                          <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-heart w-4 h-4 mr-2"
                            >
                              <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                            </svg>
                            Wishlist
                          </button>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                          <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                            <div className="p-8">
                              <div className="flex items-start gap-4 mb-6">
                                <div className="w-16 h-16 bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg flex items-center justify-center">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-plane w-8 h-8 text-primary"
                                  >
                                    <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
                                  </svg>
                                </div>
                                <div className="flex-1">
                                  <h3 className="font-bold text-lg text-gray-900 mb-2">
                                    Paris, France
                                  </h3>
                                  <p className="text-sm text-gray-600 mb-3">May 12 - 19, 2024</p>
                                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 bg-gray-100 text-gray-700">
                                    completed
                                  </div>
                                </div>
                              </div>
                              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 text-primary hover:bg-primary/10 bg-transparent">
                                View Details
                              </button>
                            </div>
                          </div>
                          <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                            <div className="p-8">
                              <div className="flex items-start gap-4 mb-6">
                                <div className="w-16 h-16 bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg flex items-center justify-center">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-plane w-8 h-8 text-primary"
                                  >
                                    <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
                                  </svg>
                                </div>
                                <div className="flex-1">
                                  <h3 className="font-bold text-lg text-gray-900 mb-2">
                                    Tokyo, Japan
                                  </h3>
                                  <p className="text-sm text-gray-600 mb-3">Dec 2 - 9, 2024</p>
                                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 bg-green-100 text-green-700">
                                    upcoming
                                  </div>
                                </div>
                              </div>
                              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 text-primary hover:bg-primary/10 bg-transparent">
                                View Details
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                    )}

                    {activeTab === "meetups" && (
                      <div
                        className="ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-8 mt-0"
                      >
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">My Meetups</h2>
                          <p className="text-gray-600">Upcoming and past meetups you've joined</p>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                          <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                            <div className="p-8">
                              <div className="flex items-start gap-4 mb-6">
                                <div className="w-16 h-16 bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg flex items-center justify-center">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-calendar w-8 h-8 text-primary"
                                  >
                                    <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                                    <line x1={16} x2={16} y1={2} y2={6} />
                                    <line x1={8} x2={8} y1={2} y2={6} />
                                    <line x1={3} x2={21} y1={10} y2={10} />
                                  </svg>
                                </div>
                                <div className="flex-1">
                                  <h3 className="font-bold text-lg text-gray-900 mb-2">
                                    Hiking Adventure
                                  </h3>
                                  <p className="text-sm text-gray-600 mb-2">July 15, 2024</p>
                                  <p className="text-sm text-gray-500 mb-3">Local Mountains</p>
                                  <div className="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-users w-4 h-4 text-gray-400"
                                    >
                                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                      <circle cx={9} cy={7} r={4} />
                                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                    </svg>
                                    <span className="text-sm text-gray-600">15 attendees</span>
                                  </div>
                                </div>
                              </div>
                              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 text-primary hover:bg-primary/10 bg-transparent">
                                View Meetup
                              </button>
                            </div>
                          </div>
                          <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                            <div className="p-8">
                              <div className="flex items-start gap-4 mb-6">
                                <div className="w-16 h-16 bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg flex items-center justify-center">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-calendar w-8 h-8 text-primary"
                                  >
                                    <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                                    <line x1={16} x2={16} y1={2} y2={6} />
                                    <line x1={8} x2={8} y1={2} y2={6} />
                                    <line x1={3} x2={21} y1={10} y2={10} />
                                  </svg>
                                </div>
                                <div className="flex-1">
                                  <h3 className="font-bold text-lg text-gray-900 mb-2">
                                    City Exploration
                                  </h3>
                                  <p className="text-sm text-gray-600 mb-2">August 20, 2024</p>
                                  <p className="text-sm text-gray-500 mb-3">Downtown Area</p>
                                  <div className="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-users w-4 h-4 text-gray-400"
                                    >
                                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                      <circle cx={9} cy={7} r={4} />
                                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                    </svg>
                                    <span className="text-sm text-gray-600">10 attendees</span>
                                  </div>
                                </div>
                              </div>
                              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 text-primary hover:bg-primary/10 bg-transparent">
                                View Meetup
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                    )}

                    {activeTab === "settings" && (
                      <div className="space-y-8">
                        {/* Account Info Update */}
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">Account Settings</h2>
                          <p className="text-gray-600">
                            Manage your account preferences and privacy settings
                          </p>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                          <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                            <div className="flex flex-col space-y-1.5 p-6 pb-4">
                              <h3 className="font-semibold tracking-tight flex items-center gap-2 text-base">
                                <div className="p-1.5 bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-user w-4 h-4 text-primary"
                                  >
                                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                                    <circle cx={12} cy={7} r={4} />
                                  </svg>
                                </div>
                                Profile Information
                              </h3>
                              <p className="text-sm text-gray-600">
                                Update your personal information and profile details
                              </p>
                            </div>
                            <div className="p-6 pt-0 space-y-4 px-6 pb-8">
                              <div className="space-y-2">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="name"
                                >
                                  Full Name
                                </label>
                                <input
                                  className="flex h-10 w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 text-sm"
                                  id="name"
                                  type="text"
                                  defaultValue="Sarah Chen"
                                />
                              </div>
                              <div className="space-y-2">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="email"
                                >
                                  Email
                                </label>
                                <input
                                  className="flex h-10 w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 text-sm"
                                  id="email"
                                  type="email"
                                  defaultValue="sarah.chen@email.com"
                                />
                              </div>
                              <div className="space-y-2">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="phone"
                                >
                                  Phone
                                </label>
                                <input
                                  className="flex h-10 w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 text-sm"
                                  id="phone"
                                  type="text"
                                  defaultValue="+1 (555) 123-4567"
                                />
                              </div>
                              <div className="space-y-2">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="location"
                                >
                                  Location
                                </label>
                                <input
                                  className="flex h-10 w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 text-sm"
                                  id="location"
                                  type="text"
                                  defaultValue="San Francisco, CA"
                                />
                              </div>
                              <div className="space-y-2">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="bio"
                                >
                                  Bio
                                </label>
                                <textarea
                                  className="flex w-full rounded-md border bg-background px-3 py-2 ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 min-h-[80px] text-sm"
                                  id="bio"
                                  defaultValue={
                                    "Adventure seeker and culture enthusiast. Love discovering hidden gems and sharing travel stories with fellow wanderers."
                                  }
                                />
                              </div>
                              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-sm mt-6">
                                Save Changes
                              </button>
                            </div>
                          </div>
                          <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                            <div className="flex flex-col space-y-1.5 p-6 pb-3">
                              <h3 className="font-semibold tracking-tight flex items-center gap-2 text-base">
                                <div className="p-1.5 bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-lock w-4 h-4 text-primary"
                                  >
                                    <rect width={18} height={11} x={3} y={11} rx={2} ry={2} />
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                  </svg>
                                </div>
                                Security
                              </h3>
                              <p className="text-sm text-gray-600">
                                Manage your password and security preferences
                              </p>
                            </div>
                            <div className="p-6 pt-0 space-y-3">
                              <div className="space-y-1">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="current-password"
                                >
                                  Current Password
                                </label>
                                <div className="relative">
                                  <input
                                    className="flex h-10 w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 pr-10 text-sm"
                                    id="current-password"
                                    placeholder="Enter current password"
                                    type="password"
                                  />
                                  <button
                                    className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:text-accent-foreground rounded-md absolute right-0 top-0 h-full px-2 py-2 hover:bg-transparent"
                                    type="button"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-eye h-3.5 w-3.5 text-gray-400"
                                    >
                                      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </button>
                                </div>
                              </div>
                              <div className="space-y-1">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="new-password"
                                >
                                  New Password
                                </label>
                                <div className="relative">
                                  <input
                                    className="flex h-10 w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 pr-10 text-sm"
                                    id="new-password"
                                    placeholder="Enter new password"
                                    type="password"
                                  />
                                </div>
                              </div>
                              <div className="space-y-1">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="confirm-password"
                                >
                                  Confirm Password
                                </label>
                                <div className="relative">
                                  <input
                                    className="flex h-10 w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 pr-10 text-sm"
                                    id="confirm-password"
                                    placeholder="Confirm new password"
                                    type="password"
                                  />
                                </div>
                              </div>
                              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-sm">
                                Update Password
                              </button>
                            </div>
                          </div>
                          <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                            <div className="flex flex-col space-y-1.5 p-6 pb-3">
                              <h3 className="font-semibold tracking-tight flex items-center gap-2 text-base">
                                <div className="p-1.5 bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-bell w-4 h-4 text-primary"
                                  >
                                    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
                                    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
                                  </svg>
                                </div>
                                Notifications
                              </h3>
                              <p className="text-sm text-gray-600">
                                Choose what notifications you want to receive
                              </p>
                            </div>
                            <div className="p-6 pt-0 space-y-3">
                              <ToggleRow
                                  title="Email Notifications"
                                  desc="Receive updates via email"
                                  value={toggles.email}
                                  onToggle={() => toggleSwitch(setToggles, "email")}
                                />
                                <ToggleRow
                                  title="Push Notifications"
                                  desc="Receive push notifications"
                                  value={toggles.push}
                                  onToggle={() => toggleSwitch(setToggles, "push")}
                                />
                                <ToggleRow
                                  title="SMS Notifications"
                                  desc="Receive text messages"
                                  value={toggles.sms}
                                  onToggle={() => toggleSwitch(setToggles, "sms")}
                                />
                                <ToggleRow
                                  title="Marketing Emails"
                                  desc="Receive promotional content"
                                  value={toggles.marketing}
                                  onToggle={() => toggleSwitch(setToggles, "marketing")}
                                />
                            </div>
                          </div>
                          <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                            <div className="flex flex-col space-y-1.5 p-6 pb-3">
                              <h3 className="font-semibold tracking-tight flex items-center gap-2 text-base">
                                <div className="p-1.5 bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-shield w-4 h-4 text-primary"
                                  >
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                                  </svg>
                                </div>
                                Privacy
                              </h3>
                              <p className="text-sm text-gray-600">
                                Control who can see your information
                              </p>
                            </div>
                            <div className="p-6 pt-0 space-y-3">
                              <ToggleRow
                                  title="Profile Visible"
                                  desc="Make your profile public"
                                  value={privacy.profileVisible}
                                  onToggle={() => togglePrivacy("profileVisible")}
                                />
                                <ToggleRow
                                  title="Show Email"
                                  desc="Display email on profile"
                                  value={privacy.showEmail}
                                  onToggle={() => togglePrivacy("showEmail")}
                                />
                                <ToggleRow
                                  title="Show Phone"
                                  desc="Display travel history"
                                  value={privacy.showPhone}
                                  onToggle={() => togglePrivacy("showPhone")}
                                />
                            </div>
                          </div>
                        </div>




                        

                      </div>
                    )}
                  </div>
                </div>
              </div>

          </div>
        

            <div className="sm:hidden">
              <div className="bg-white/95 backdrop-blur-sm border-b border-gray-200/50 py-3">
                <div className="flex items-center gap-3">
                  <span className="relative flex shrink-0 overflow-hidden rounded-full w-14 h-14 border-2 border-primary/20">
                    <img
                      className="aspect-square h-full w-full"
                      alt="Sarah Chen"
                      src="/assets/images/member-profile-1.png"
                    />
                  </span>
                  <div className="flex-1 min-w-0">
                    <h1 className="text-lg font-bold text-gray-900 truncate">Sarah Chen</h1>
                    <p className="text-xs text-gray-600 truncate">San Francisco, CA</p>
                    <div className="flex items-center gap-3 mt-0.5">
                      <span className="text-[10px] text-gray-500">24 trips</span>
                      <span className="text-[10px] text-gray-500">4 communities</span>
                    </div>
                  </div>
                  <div className="flex gap-1">
                    <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border bg-background hover:text-accent-foreground rounded-md border-primary/20 text-primary hover:bg-primary/5 h-8 w-8 p-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-pen-square w-3.5 h-3.5"
                      >
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                        <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
                      </svg>
                    </button>
                    <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground rounded-md border-red-300 text-red-600 hover:bg-red-50 h-8 w-8 p-0 bg-transparent">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-log-out w-3.5 h-3.5"
                      >
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                        <polyline points="16 17 21 12 16 7" />
                        <line x1={21} x2={9} y1={12} y2={12} />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <div
                role="tablist"
                aria-orientation="horizontal"
                className="items-center justify-center text-muted-foreground grid w-full grid-cols-4 h-12 bg-gray-50/80 backdrop-blur-sm border-0 shadow-none rounded-lg p-0.5"
              >
                {/* COMMUNITY */}
                <button
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "community"}
                  onClick={() => setActiveTab("community")}
                  className={`whitespace-nowrap py-1.5 font-medium flex flex-col items-center justify-center gap-0.5 text-sm rounded-md transition-all duration-200 h-full px-0.5
                    ${activeTab === "community"
                      ? "bg-primary/10 text-primary shadow-sm"
                      : "hover:bg-gray-100"}
                  `}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-4 h-4"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                  <span className="text-[10px]">Community</span>
                </button>

                {/* TRIPS */}
                <button
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "trips"}
                  onClick={() => setActiveTab("trips")}
                  className={`whitespace-nowrap py-1.5 font-medium flex flex-col items-center justify-center gap-0.5 text-sm rounded-md transition-all duration-200 h-full px-0.5
                    ${activeTab === "trips"
                      ? "bg-primary/10 text-primary shadow-sm"
                      : "hover:bg-gray-100"}
                  `}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-4 h-4"
                  >
                    <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
                  </svg>
                  <span className="text-[10px]">Trips</span>
                </button>

                {/* MEETUPS */}
                <button
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "meetups"}
                  onClick={() => setActiveTab("meetups")}
                  className={`whitespace-nowrap py-1.5 font-medium flex flex-col items-center justify-center gap-0.5 text-sm rounded-md transition-all duration-200 h-full px-0.5
                    ${activeTab === "meetups"
                      ? "bg-primary/10 text-primary shadow-sm"
                      : "hover:bg-gray-100"}
                  `}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-4 h-4"
                  >
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                  <span className="text-[10px]">Meetups</span>
                </button>

                {/* SETTINGS */}
                <button
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "settings"}
                  onClick={() => setActiveTab("settings")}
                  className={`whitespace-nowrap py-1.5 font-medium flex flex-col items-center justify-center gap-0.5 text-sm rounded-md transition-all duration-200 h-full px-0.5
                    ${activeTab === "settings"
                      ? "bg-primary/10 text-primary shadow-sm"
                      : "hover:bg-gray-100"}
                  `}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-4 h-4"
                  >
                    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                  <span className="text-[10px]">Settings</span>
                </button>
              </div>

              {/* TAB CONTENT */}
              <div className="mt-4 rounded-lg p-4 px-0 bg-white text-sm">
                {activeTab === "community" && (
                  <div>
                    <div className="">
                      <div dir="ltr" data-orientation="horizontal" className="w-full">
                        <div
                          data-state="active"
                          data-orientation="horizontal"
                          role="tabpanel"
                          aria-labelledby="radix-«r27»-trigger-community"
                          id="radix-«r27»-content-community"
                          tabIndex={0}
                          className="ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-3 mt-0"
                          style={{}}
                        >
                          <div className="flex justify-between items-center">
                            <div>
                              <h2 className="text-lg font-bold text-gray-900">My Communities</h2>
                              <p className="text-sm text-gray-600 mt-1">
                                Connect with like-minded travelers and share experiences
                              </p>
                            </div>
                            <div className="flex gap-2">
                              <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md border-primary/30 text-primary hover:bg-primary/10 bg-transparent text-xs px-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-search w-3.5 h-3.5 mr-1"
                                >
                                  <circle cx={11} cy={11} r={8} />
                                  <path d="m21 21-4.3-4.3" />
                                </svg>
                                Discover
                              </button>
                              <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 h-9 rounded-md bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-white shadow-lg hover:shadow-xl transition-all duration-200 text-xs px-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-plus w-3.5 h-3.5 mr-1"
                                >
                                  <path d="M5 12h14" />
                                  <path d="M12 5v14" />
                                </svg>
                                Create
                              </button>
                            </div>
                          </div>
                          <div className="space-y-4">
                            <div className="flex items-center justify-between">
                              <h3 className="text-base font-semibold text-gray-900">
                                Communities I'm Part Of
                              </h3>
                              <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 bg-primary/10 text-primary text-xs">
                                4 Communities
                              </div>
                            </div>
                            <div className="grid grid-cols-1 gap-4">
                              <div className="rounded-lg text-card-foreground overflow-hidden bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                                <div className="relative overflow-hidden">
                                  <img
                                    alt="Solo Female Travelers"
                                    className="w-full h-28 object-cover group-hover:scale-105 transition-transform duration-300"
                                    src="/assets/images/solo-mountain-vista.png"
                                  />
                                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                                  <div className="absolute top-2 left-2 flex gap-1">
                                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-red-500 text-white shadow-lg text-xs">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-crown w-2.5 h-2.5 mr-0.5"
                                      >
                                        <path d="m2 4 3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14" />
                                      </svg>
                                      Admin
                                    </div>
                                  </div>
                                  <div className="absolute bottom-2 right-2">
                                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-gray-900 backdrop-blur-sm text-xs">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-users w-2.5 h-2.5 mr-0.5"
                                      >
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                        <circle cx={9} cy={7} r={4} />
                                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                      </svg>
                                      15,420
                                    </div>
                                  </div>
                                </div>
                                <div className="p-4">
                                  <h4 className="font-bold text-base text-gray-900 mb-2">
                                    Solo Female Travelers
                                  </h4>
                                  <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                                    A supportive community for women traveling alone
                                  </p>
                                  <div className="flex items-center justify-between text-xs text-gray-500 mb-3">
                                    <span>Joined March 2023</span>
                                    <span className="font-medium text-primary">Admin</span>
                                  </div>
                                  <div className="flex gap-2">
                                    <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-9 rounded-md px-3 flex-1 bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-xs">
                                      View Community
                                    </button>
                                    <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md border-primary/30 text-primary hover:bg-primary/10 bg-transparent px-2">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-settings w-3.5 h-3.5"
                                      >
                                        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
                                        <circle cx={12} cy={12} r={3} />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="rounded-lg text-card-foreground overflow-hidden bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                                <div className="relative overflow-hidden">
                                  <img
                                    alt="Asian Food Explorers"
                                    className="w-full h-28 object-cover group-hover:scale-105 transition-transform duration-300"
                                    src="/assets/images/bustling-asian-street-food.png"
                                  />
                                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                                  <div className="absolute top-2 left-2 flex gap-1">
                                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-blue-500 text-white shadow-lg text-xs">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-shield w-2.5 h-2.5 mr-0.5"
                                      >
                                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                                      </svg>
                                      Mod
                                    </div>
                                  </div>
                                  <div className="absolute bottom-2 right-2">
                                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-gray-900 backdrop-blur-sm text-xs">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-users w-2.5 h-2.5 mr-0.5"
                                      >
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                        <circle cx={9} cy={7} r={4} />
                                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                      </svg>
                                      8,934
                                    </div>
                                  </div>
                                </div>
                                <div className="p-4">
                                  <h4 className="font-bold text-base text-gray-900 mb-2">
                                    Asian Food Explorers
                                  </h4>
                                  <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                                    Discovering authentic Asian cuisine around the world
                                  </p>
                                  <div className="flex items-center justify-between text-xs text-gray-500 mb-3">
                                    <span>Joined June 2023</span>
                                    <span className="font-medium text-primary">Moderator</span>
                                  </div>
                                  <div className="flex gap-2">
                                    <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-9 rounded-md px-3 flex-1 bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-xs">
                                      View Community
                                    </button>
                                    <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md border-primary/30 text-primary hover:bg-primary/10 bg-transparent px-2">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-settings w-3.5 h-3.5"
                                      >
                                        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
                                        <circle cx={12} cy={12} r={3} />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="rounded-lg text-card-foreground overflow-hidden bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                                <div className="relative overflow-hidden">
                                  <img
                                    alt="SF Bay Area Travelers"
                                    className="w-full h-28 object-cover group-hover:scale-105 transition-transform duration-300"
                                    src="/assets/images/coastal-mountain-vista.png"
                                  />
                                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                                  <div className="absolute top-2 left-2 flex gap-1">
                                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-gray-600 text-white shadow-lg text-xs">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-lock w-2.5 h-2.5 mr-0.5"
                                      >
                                        <rect width={18} height={11} x={3} y={11} rx={2} ry={2} />
                                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                      </svg>
                                      Private
                                    </div>
                                  </div>
                                  <div className="absolute bottom-2 right-2">
                                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-gray-900 backdrop-blur-sm text-xs">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-users w-2.5 h-2.5 mr-0.5"
                                      >
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                        <circle cx={9} cy={7} r={4} />
                                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                      </svg>
                                      2,156
                                    </div>
                                  </div>
                                </div>
                                <div className="p-4">
                                  <h4 className="font-bold text-base text-gray-900 mb-2">
                                    SF Bay Area Travelers
                                  </h4>
                                  <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                                    Local travelers from San Francisco Bay Area
                                  </p>
                                  <div className="flex items-center justify-between text-xs text-gray-500 mb-3">
                                    <span>Joined August 2023</span>
                                    <span className="font-medium text-primary">Member</span>
                                  </div>
                                  <div className="flex gap-2">
                                    <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-9 rounded-md px-3 flex-1 bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-xs">
                                      View Community
                                    </button>
                                    <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md border-primary/30 text-primary hover:bg-primary/10 bg-transparent px-2">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-settings w-3.5 h-3.5"
                                      >
                                        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
                                        <circle cx={12} cy={12} r={3} />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="rounded-lg text-card-foreground overflow-hidden bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                                <div className="relative overflow-hidden">
                                  <img
                                    alt="Photography Enthusiasts"
                                    className="w-full h-28 object-cover group-hover:scale-105 transition-transform duration-300"
                                    src="/assets/images/serene-beach-read.png"
                                  />
                                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                                  <div className="absolute top-2 left-2 flex gap-1" />
                                  <div className="absolute bottom-2 right-2">
                                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-gray-900 backdrop-blur-sm text-xs">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-users w-2.5 h-2.5 mr-0.5"
                                      >
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                        <circle cx={9} cy={7} r={4} />
                                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                      </svg>
                                      12,678
                                    </div>
                                  </div>
                                </div>
                                <div className="p-4">
                                  <h4 className="font-bold text-base text-gray-900 mb-2">
                                    Photography Enthusiasts
                                  </h4>
                                  <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                                    Capturing the world through our lenses
                                  </p>
                                  <div className="flex items-center justify-between text-xs text-gray-500 mb-3">
                                    <span>Joined October 2023</span>
                                    <span className="font-medium text-primary">Member</span>
                                  </div>
                                  <div className="flex gap-2">
                                    <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-9 rounded-md px-3 flex-1 bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-xs">
                                      View Community
                                    </button>
                                    <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md border-primary/30 text-primary hover:bg-primary/10 bg-transparent px-2">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-settings w-3.5 h-3.5"
                                      >
                                        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
                                        <circle cx={12} cy={12} r={3} />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="space-y-6">
                            <div className="flex items-center justify-between">
                              <h3 className="text-xl font-semibold text-gray-900">
                                Suggested for You
                              </h3>
                              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:text-accent-foreground h-10 px-4 py-2 text-primary hover:bg-primary/10">
                                View All
                              </button>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                              <div className="rounded-lg text-card-foreground overflow-hidden bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                                <div className="relative overflow-hidden">
                                  <img
                                    alt="Digital Nomads"
                                    className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300"
                                    src="/assets/images/manhattan-twilight.png"
                                  />
                                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                                  <div className="absolute bottom-3 right-3">
                                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-gray-900 backdrop-blur-sm">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-users w-3 h-3 mr-1"
                                      >
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                        <circle cx={9} cy={7} r={4} />
                                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                      </svg>
                                      25,340
                                    </div>
                                  </div>
                                </div>
                                <div className="p-6">
                                  <h4 className="font-bold text-lg text-gray-900 mb-2">
                                    Digital Nomads
                                  </h4>
                                  <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                                    Working remotely while traveling the world
                                  </p>
                                  <div className="flex gap-2">
                                    <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-9 rounded-md px-3 flex-1 bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-user-plus w-4 h-4 mr-2"
                                      >
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                        <circle cx={9} cy={7} r={4} />
                                        <line x1={19} x2={19} y1={8} y2={14} />
                                        <line x1={22} x2={16} y1={11} y2={11} />
                                      </svg>
                                      Join Community
                                    </button>
                                    <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md px-3 border-primary/30 text-primary hover:bg-primary/10 bg-transparent">
                                      Preview
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="rounded-lg text-card-foreground overflow-hidden bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                                <div className="relative overflow-hidden">
                                  <img
                                    alt="Budget Backpackers"
                                    className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300"
                                    src="/assets/images/tokyo-fuji-skyline.png"
                                  />
                                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                                  <div className="absolute bottom-3 right-3">
                                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-gray-900 backdrop-blur-sm">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-users w-3 h-3 mr-1"
                                      >
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                        <circle cx={9} cy={7} r={4} />
                                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                      </svg>
                                      18,765
                                    </div>
                                  </div>
                                </div>
                                <div className="p-6">
                                  <h4 className="font-bold text-lg text-gray-900 mb-2">
                                    Budget Backpackers
                                  </h4>
                                  <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                                    Travel more, spend less - budget travel tips and tricks
                                  </p>
                                  <div className="flex gap-2">
                                    <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-9 rounded-md px-3 flex-1 bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-user-plus w-4 h-4 mr-2"
                                      >
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                        <circle cx={9} cy={7} r={4} />
                                        <line x1={19} x2={19} y1={8} y2={14} />
                                        <line x1={22} x2={16} y1={11} y2={11} />
                                      </svg>
                                      Join Community
                                    </button>
                                    <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md px-3 border-primary/30 text-primary hover:bg-primary/10 bg-transparent">
                                      Preview
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="space-y-6">
                            <h3 className="text-xl font-semibold text-gray-900">Recent Activity</h3>
                            <div className="space-y-4">
                              <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                                <div className="p-3">
                                  <div className="flex gap-4">
                                    <span className="relative flex shrink-0 overflow-hidden rounded-full w-12 h-12 border-2 border-primary/20">
                                      <img
                                        className="aspect-square h-full w-full"
                                        alt="Sarah Chen"
                                        src="/assets/images/member-profile-1.png"
                                      />
                                    </span>
                                    <div className="flex-1">
                                      <div className="flex items-center gap-3 mb-3">
                                        <span className="font-semibold text-gray-900">
                                          Sarah Chen
                                        </span>
                                        <span className="text-gray-500 text-sm">2 hours ago</span>
                                      </div>
                                      <p className="mb-4 text-gray-700 leading-relaxed">
                                        Just discovered the most amazing ramen shop in Shibuya! The
                                        tonkotsu broth was incredible 🍜
                                      </p>
                                      <div className="flex items-center gap-6 text-gray-500">
                                        <button className="flex items-center gap-2 hover:text-red-500 transition-colors duration-200 px-3 py-1.5 rounded-lg hover:bg-red-50">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-heart w-4 h-4"
                                          >
                                            <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                                          </svg>
                                          <span className="font-medium">23</span>
                                        </button>
                                        <button className="flex items-center gap-2 hover:text-blue-500 transition-colors duration-200 px-3 py-1.5 rounded-lg hover:bg-blue-50">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-message-circle w-4 h-4"
                                          >
                                            <path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z" />
                                          </svg>
                                          <span className="font-medium">5</span>
                                        </button>
                                        <button className="flex items-center gap-2 hover:text-green-500 transition-colors duration-200 px-3 py-1.5 rounded-lg hover:bg-green-50">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-share2 w-4 h-4"
                                          >
                                            <circle cx={18} cy={5} r={3} />
                                            <circle cx={6} cy={12} r={3} />
                                            <circle cx={18} cy={19} r={3} />
                                            <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
                                            <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
                                          </svg>
                                          Share
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                                <div className="p-3">
                                  <div className="flex gap-4">
                                    <span className="relative flex shrink-0 overflow-hidden rounded-full w-12 h-12 border-2 border-primary/20">
                                      <img
                                        className="aspect-square h-full w-full"
                                        alt="Sarah Chen"
                                        src="/assets/images/member-profile-1.png"
                                      />
                                    </span>
                                    <div className="flex-1">
                                      <div className="flex items-center gap-3 mb-3">
                                        <span className="font-semibold text-gray-900">
                                          Sarah Chen
                                        </span>
                                        <span className="text-gray-500 text-sm">1 day ago</span>
                                        <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 bg-blue-100 text-blue-700">
                                          Review
                                        </div>
                                      </div>
                                      <p className="mb-4 text-gray-700 leading-relaxed">
                                        Reviewed "Tokyo Food Tour" - An authentic culinary journey
                                        through local neighborhoods
                                      </p>
                                      <div className="flex items-center gap-6 text-gray-500">
                                        <button className="flex items-center gap-2 hover:text-red-500 transition-colors duration-200 px-3 py-1.5 rounded-lg hover:bg-red-50">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-heart w-4 h-4"
                                          >
                                            <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                                          </svg>
                                          <span className="font-medium">45</span>
                                        </button>
                                        <button className="flex items-center gap-2 hover:text-blue-500 transition-colors duration-200 px-3 py-1.5 rounded-lg hover:bg-blue-50">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-message-circle w-4 h-4"
                                          >
                                            <path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z" />
                                          </svg>
                                          <span className="font-medium">12</span>
                                        </button>
                                        <button className="flex items-center gap-2 hover:text-green-500 transition-colors duration-200 px-3 py-1.5 rounded-lg hover:bg-green-50">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-share2 w-4 h-4"
                                          >
                                            <circle cx={18} cy={5} r={3} />
                                            <circle cx={6} cy={12} r={3} />
                                            <circle cx={18} cy={19} r={3} />
                                            <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
                                            <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
                                          </svg>
                                          Share
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          data-state="inactive"
                          data-orientation="horizontal"
                          role="tabpanel"
                          aria-labelledby="radix-«r27»-trigger-trips"
                          id="radix-«r27»-content-trips"
                          tabIndex={0}
                          className="ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-3 mt-0"
                          hidden=""
                        />
                        <div
                          data-state="inactive"
                          data-orientation="horizontal"
                          role="tabpanel"
                          aria-labelledby="radix-«r27»-trigger-meetups"
                          id="radix-«r27»-content-meetups"
                          tabIndex={0}
                          className="ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-3 mt-0"
                          hidden=""
                        />
                        <div
                          data-state="inactive"
                          data-orientation="horizontal"
                          role="tabpanel"
                          aria-labelledby="radix-«r27»-trigger-settings"
                          id="radix-«r27»-content-settings"
                          tabIndex={0}
                          className="ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-4 mt-0"
                          hidden=""
                        />
                      </div>
                    </div>

                  </div>
                )}

                {activeTab === "trips" && (
                  <div>
                    <div className="">
                    <div dir="ltr" data-orientation="horizontal" className="w-full">
                      <div
                        data-state="inactive"
                        data-orientation="horizontal"
                        role="tabpanel"
                        aria-labelledby="radix-«r27»-trigger-community"
                        id="radix-«r27»-content-community"
                        tabIndex={0}
                        className="ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-3 mt-0"
                        style={{}}
                        hidden=""
                      />
                      <div
                        data-state="active"
                        data-orientation="horizontal"
                        role="tabpanel"
                        aria-labelledby="radix-«r27»-trigger-trips"
                        id="radix-«r27»-content-trips"
                        tabIndex={0}
                        className="ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-3 mt-0"
                      >
                        <div className="flex flex-col gap-3">
                          <div>
                            <h2 className="text-lg font-bold text-gray-900">
                              My Travel Bookings
                            </h2>
                            <p className="text-sm text-gray-600 mt-1">
                              Manage your booked trips and travel history
                            </p>
                          </div>
                          <div className="flex gap-2">
                            <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md border-primary/30 text-primary hover:bg-primary/10 bg-transparent text-xs px-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-search w-3.5 h-3.5 mr-1"
                              >
                                <circle cx={11} cy={11} r={8} />
                                <path d="m21 21-4.3-4.3" />
                              </svg>
                              Search
                            </button>
                            <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 h-9 rounded-md bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-white shadow-lg hover:shadow-xl transition-all duration-200 text-xs px-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-heart w-3.5 h-3.5 mr-1"
                              >
                                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                              </svg>
                              Wishlist
                            </button>
                          </div>
                        </div>
                        <div className="space-y-3">
                          <div className="flex items-center justify-between">
                            <h3 className="text-base font-semibold text-gray-900">My Bookings</h3>
                            <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 bg-green-100 text-green-700 text-xs">
                              1 Active Booking
                            </div>
                          </div>
                          <div className="grid grid-cols-1 gap-3">
                            <div className="rounded-lg text-card-foreground overflow-hidden bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                              <div className="relative overflow-hidden">
                                <img
                                  alt="Thailand Island Hopping"
                                  className="w-full h-28 object-cover group-hover:scale-105 transition-transform duration-300"
                                  src="/assets/images/bustling-bangkok-street-food.png"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute top-2 left-2 bg-green-500 text-white shadow-lg text-xs">
                                  Confirmed
                                </div>
                                <div className="absolute bottom-2 right-2">
                                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-gray-900 backdrop-blur-sm text-xs">
                                    Ref: TH2025-001
                                  </div>
                                </div>
                              </div>
                              <div className="p-3">
                                <h4 className="font-bold text-sm text-gray-900 mb-2">
                                  Thailand Island Hopping
                                </h4>
                                <p className="text-xs text-gray-600 mb-2 flex items-center gap-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-map-pin w-3 h-3 text-primary"
                                  >
                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                    <circle cx={12} cy={10} r={3} />
                                  </svg>
                                  Phuket &amp; Phi Phi Islands
                                </p>
                                <div className="space-y-1 text-xs text-gray-600">
                                  <div className="flex justify-between">
                                    <span>Travel Date:</span>
                                    <span className="font-medium text-gray-900">
                                      Jan 28, 2025
                                    </span>
                                  </div>
                                  <div className="flex justify-between">
                                    <span>Duration:</span>
                                    <span className="font-medium text-gray-900">
                                      8 days, 7 nights
                                    </span>
                                  </div>
                                  <div className="flex justify-between">
                                    <span>Travelers:</span>
                                    <span className="font-medium text-gray-900">2 persons</span>
                                  </div>
                                  <div className="flex justify-between">
                                    <span>Total Paid:</span>
                                    <span className="font-bold text-sm text-primary">$1,699</span>
                                  </div>
                                </div>
                                <div className="flex gap-2 mt-3">
                                  <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-9 rounded-md px-3 flex-1 bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-xs">
                                    View Details
                                  </button>
                                  <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md border-primary/30 text-primary hover:bg-primary/10 bg-transparent text-xs px-2">
                                    Manage
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="space-y-4">
                          <div className="flex items-center justify-between">
                            <h3 className="text-base font-semibold text-gray-900">My Wishlist</h3>
                            <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 bg-pink-100 text-pink-700 text-xs">
                              1 Saved Package
                            </div>
                          </div>
                          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                            <div className="rounded-lg text-card-foreground overflow-hidden bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                              <div className="relative overflow-hidden">
                                <img
                                  alt="Iceland Northern Lights"
                                  className="w-full h-40 object-cover group-hover:scale-105 transition-transform duration-300"
                                  src="/assets/images/coastal-mountain-vista.png"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                                <div className="absolute top-3 left-3">
                                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-red-500 text-white shadow-lg">
                                    12% OFF
                                  </div>
                                </div>
                                <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:text-accent-foreground rounded-md absolute top-3 right-3 w-8 h-8 p-0 bg-white/20 backdrop-blur-sm hover:bg-white/30">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-heart w-4 h-4 fill-red-500 text-red-500"
                                  >
                                    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                                  </svg>
                                </button>
                                <div className="absolute bottom-3 left-3">
                                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-gray-900 backdrop-blur-sm">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star w-3 h-3 fill-yellow-400 text-yellow-400 mr-1"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    4.9 (78)
                                  </div>
                                </div>
                              </div>
                              <div className="p-6">
                                <h4 className="font-bold text-lg text-gray-900 mb-2">
                                  Iceland Northern Lights
                                </h4>
                                <p className="text-gray-600 mb-3 flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-map-pin w-4 h-4 text-primary"
                                  >
                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                    <circle cx={12} cy={10} r={3} />
                                  </svg>
                                  Reykjavik, Iceland
                                </p>
                                <div className="flex items-center justify-between mb-4">
                                  <div>
                                    <span className="text-sm text-gray-500 line-through">
                                      $2,599
                                    </span>
                                    <div className="font-bold text-xl text-primary">$2,299</div>
                                  </div>
                                  <div className="text-right text-sm text-gray-600">
                                    Next: Nov 15, 2025
                                  </div>
                                </div>
                                <div className="flex gap-2">
                                  <a target="_blank" href="https://wa.me/918920866123" className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-9 rounded-md px-3 flex-1 bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary">
                                    Book Now
                                  </a>
                                  <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md px-3 border-red-300 text-red-600 hover:bg-red-50 bg-transparent">
                                    Remove
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-state="inactive"
                        data-orientation="horizontal"
                        role="tabpanel"
                        aria-labelledby="radix-«r27»-trigger-meetups"
                        id="radix-«r27»-content-meetups"
                        tabIndex={0}
                        className="ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-3 mt-0"
                        hidden=""
                      />
                      <div
                        data-state="inactive"
                        data-orientation="horizontal"
                        role="tabpanel"
                        aria-labelledby="radix-«r27»-trigger-settings"
                        id="radix-«r27»-content-settings"
                        tabIndex={0}
                        className="ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-4 mt-0"
                        hidden=""
                      />
                    </div>
                  </div>

                  </div>
                )}

                {activeTab === "meetups" && (
                  <div>
                    <div
                      className="ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 space-y-3 mt-0"
                    >
                      <div className="flex flex-col gap-3">
                        <div>
                          <h2 className="text-lg font-bold text-gray-900">My Meetups</h2>
                          <p className="text-sm text-gray-600 mt-1">
                            Connect with travelers and join exciting adventures
                          </p>
                        </div>
                        <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 h-10 px-4 py-2 bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-white shadow-lg hover:shadow-xl transition-all duration-200 text-xs">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-calendar w-3.5 h-3.5 mr-1.5"
                          >
                            <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                            <line x1={16} x2={16} y1={2} y2={6} />
                            <line x1={8} x2={8} y1={2} y2={6} />
                            <line x1={3} x2={21} y1={10} y2={10} />
                          </svg>
                          Create Meetup
                        </button>
                      </div>
                      <div className="space-y-4">
                        <div className="flex items-center justify-between">
                          <h3 className="text-base font-semibold text-gray-900">
                            Upcoming Meetups
                          </h3>
                          <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 bg-blue-100 text-blue-700 text-xs">
                            2 Upcoming
                          </div>
                        </div>
                        <div className="grid grid-cols-1 gap-4">
                          <div className="rounded-lg text-card-foreground overflow-hidden bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                            <div className="relative overflow-hidden">
                              <img
                                alt="SF Food Crawl"
                                className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300"
                                src="/assets/images/bustling-asian-street-food.png"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                              <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute top-2 left-2 bg-green-500 text-white shadow-lg text-xs">
                                Upcoming
                              </div>
                              <div className="absolute top-2 right-2">
                                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-gray-900 backdrop-blur-sm text-xs">
                                  10 days left
                                </div>
                              </div>
                            </div>
                            <div className="p-4">
                              <h3 className="font-bold text-base text-gray-900 mb-3">
                                SF Food Crawl
                              </h3>
                              <div className="space-y-2 text-gray-600">
                                <div className="flex items-center gap-2">
                                  <div className="p-1 bg-primary/10 rounded-lg">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-calendar w-3.5 h-3.5 text-primary"
                                    >
                                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                                      <line x1={16} x2={16} y1={2} y2={6} />
                                      <line x1={8} x2={8} y1={2} y2={6} />
                                      <line x1={3} x2={21} y1={10} y2={10} />
                                    </svg>
                                  </div>
                                  <span className="text-sm">Jan 15, 2025 at 6:00 PM</span>
                                </div>
                                <div className="flex items-center gap-2">
                                  <div className="p-1 bg-primary/10 rounded-lg">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-map-pin w-3.5 h-3.5 text-primary"
                                    >
                                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                      <circle cx={12} cy={10} r={3} />
                                    </svg>
                                  </div>
                                  <span className="text-sm">Chinatown, SF</span>
                                </div>
                                <div className="flex items-center gap-2">
                                  <div className="p-1 bg-primary/10 rounded-lg">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-users w-3.5 h-3.5 text-primary"
                                    >
                                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                      <circle cx={9} cy={7} r={4} />
                                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                    </svg>
                                  </div>
                                  <span className="text-sm">12 attendees confirmed</span>
                                </div>
                                <div className="flex items-center gap-2">
                                  <div className="p-1 bg-primary/10 rounded-lg">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-clock w-3.5 h-3.5 text-primary"
                                    >
                                      <circle cx={12} cy={12} r={10} />
                                      <polyline points="12 6 12 12 16 14" />
                                    </svg>
                                  </div>
                                  <span className="text-sm">Duration: 3 hours</span>
                                </div>
                              </div>
                              <div className="flex gap-2 mt-4">
                                <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-9 rounded-md px-3 flex-1 bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-xs">
                                  View Details
                                </button>
                                <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md border-primary/30 text-primary hover:bg-primary/10 bg-transparent text-xs px-2">
                                  Share
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="rounded-lg text-card-foreground overflow-hidden bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                            <div className="relative overflow-hidden">
                              <img
                                alt="Photography Walk"
                                className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300"
                                src="/assets/images/serene-beach-read.png"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                              <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute top-2 left-2 bg-green-500 text-white shadow-lg text-xs">
                                Upcoming
                              </div>
                              <div className="absolute top-2 right-2">
                                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-gray-900 backdrop-blur-sm text-xs">
                                  17 days left
                                </div>
                              </div>
                            </div>
                            <div className="p-4">
                              <h3 className="font-bold text-base text-gray-900 mb-3">
                                Photography Walk
                              </h3>
                              <div className="space-y-2 text-gray-600">
                                <div className="flex items-center gap-2">
                                  <div className="p-1 bg-primary/10 rounded-lg">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-calendar w-3.5 h-3.5 text-primary"
                                    >
                                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                                      <line x1={16} x2={16} y1={2} y2={6} />
                                      <line x1={8} x2={8} y1={2} y2={6} />
                                      <line x1={3} x2={21} y1={10} y2={10} />
                                    </svg>
                                  </div>
                                  <span className="text-sm">Jan 22, 2025 at 10:00 AM</span>
                                </div>
                                <div className="flex items-center gap-2">
                                  <div className="p-1 bg-primary/10 rounded-lg">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-map-pin w-3.5 h-3.5 text-primary"
                                    >
                                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                      <circle cx={12} cy={10} r={3} />
                                    </svg>
                                  </div>
                                  <span className="text-sm">Golden Gate Park</span>
                                </div>
                                <div className="flex items-center gap-2">
                                  <div className="p-1 bg-primary/10 rounded-lg">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-users w-3.5 h-3.5 text-primary"
                                    >
                                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                      <circle cx={9} cy={7} r={4} />
                                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                    </svg>
                                  </div>
                                  <span className="text-sm">8 attendees confirmed</span>
                                </div>
                                <div className="flex items-center gap-2">
                                  <div className="p-1 bg-primary/10 rounded-lg">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-clock w-3.5 h-3.5 text-primary"
                                    >
                                      <circle cx={12} cy={12} r={10} />
                                      <polyline points="12 6 12 12 16 14" />
                                    </svg>
                                  </div>
                                  <span className="text-sm">Duration: 2 hours</span>
                                </div>
                              </div>
                              <div className="flex gap-2 mt-4">
                                <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-9 rounded-md px-3 flex-1 bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-xs">
                                  View Details
                                </button>
                                <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md border-primary/30 text-primary hover:bg-primary/10 bg-transparent text-xs px-2">
                                  Share
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="space-y-4">
                        <div className="flex items-center justify-between">
                          <h3 className="text-base font-semibold text-gray-900">
                            Previous Meetups
                          </h3>
                          <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 bg-gray-100 text-gray-700 text-xs">
                            3 Completed
                          </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                          <div className="rounded-lg text-card-foreground overflow-hidden bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                            <div className="relative overflow-hidden">
                              <img
                                alt="Sunset Hike"
                                className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300"
                                src="/assets/images/coastal-mountain-vista.png"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                              <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute top-3 left-3 bg-gray-500 text-white shadow-lg">
                                Completed
                              </div>
                              <div className="absolute top-3 right-3">
                                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-gray-900 backdrop-blur-sm">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-star w-3 h-3 fill-yellow-400 text-yellow-400 mr-1"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>
                                  4.5
                                </div>
                              </div>
                            </div>
                            <div className="p-5">
                              <h4 className="font-bold text-lg text-gray-900 mb-3">Sunset Hike</h4>
                              <div className="space-y-2 text-sm text-gray-600">
                                <div className="flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-calendar w-3 h-3 text-primary"
                                  >
                                    <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                                    <line x1={16} x2={16} y1={2} y2={6} />
                                    <line x1={8} x2={8} y1={2} y2={6} />
                                    <line x1={3} x2={21} y1={10} y2={10} />
                                  </svg>
                                  <span>Dec 20, 2024</span>
                                </div>
                                <div className="flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-map-pin w-3 h-3 text-primary"
                                  >
                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                    <circle cx={12} cy={10} r={3} />
                                  </svg>
                                  <span>Mount Tamalpais</span>
                                </div>
                                <div className="flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-users w-3 h-3 text-primary"
                                  >
                                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                    <circle cx={9} cy={7} r={4} />
                                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                  </svg>
                                  <span>10 attended</span>
                                </div>
                              </div>
                              <div className="flex gap-2 mt-4">
                                <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md px-3 flex-1 border-primary/30 text-primary hover:bg-primary/10 bg-transparent">
                                  View Photos
                                </button>
                                <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md px-3 border-gray-300 text-gray-600 hover:bg-gray-50 bg-transparent">
                                  Review
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="rounded-lg text-card-foreground overflow-hidden bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                            <div className="relative overflow-hidden">
                              <img
                                alt="Holiday Market Visit"
                                className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300"
                                src="/assets/images/manhattan-twilight.png"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                              <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute top-3 left-3 bg-gray-500 text-white shadow-lg">
                                Completed
                              </div>
                              <div className="absolute top-3 right-3">
                                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-gray-900 backdrop-blur-sm">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-star w-3 h-3 fill-yellow-400 text-yellow-400 mr-1"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>
                                  4.2
                                </div>
                              </div>
                            </div>
                            <div className="p-5">
                              <h4 className="font-bold text-lg text-gray-900 mb-3">
                                Holiday Market Visit
                              </h4>
                              <div className="space-y-2 text-sm text-gray-600">
                                <div className="flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-calendar w-3 h-3 text-primary"
                                  >
                                    <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                                    <line x1={16} x2={16} y1={2} y2={6} />
                                    <line x1={8} x2={8} y1={2} y2={6} />
                                    <line x1={3} x2={21} y1={10} y2={10} />
                                  </svg>
                                  <span>Dec 24, 2024</span>
                                </div>
                                <div className="flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-map-pin w-3 h-3 text-primary"
                                  >
                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                    <circle cx={12} cy={10} r={3} />
                                  </svg>
                                  <span>Union Square</span>
                                </div>
                                <div className="flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-users w-3 h-3 text-primary"
                                  >
                                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                    <circle cx={9} cy={7} r={4} />
                                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                  </svg>
                                  <span>15 attended</span>
                                </div>
                              </div>
                              <div className="flex gap-2 mt-4">
                                <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md px-3 flex-1 border-primary/30 text-primary hover:bg-primary/10 bg-transparent">
                                  View Photos
                                </button>
                                <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md px-3 border-gray-300 text-gray-600 hover:bg-gray-50 bg-transparent">
                                  Review
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="rounded-lg text-card-foreground overflow-hidden bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                            <div className="relative overflow-hidden">
                              <img
                                alt="New Year's Eve Party"
                                className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300"
                                src="/assets/images/eiffel-tower-cityscape.png"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                              <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute top-3 left-3 bg-gray-500 text-white shadow-lg">
                                Completed
                              </div>
                              <div className="absolute top-3 right-3">
                                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-gray-900 backdrop-blur-sm">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-star w-3 h-3 fill-yellow-400 text-yellow-400 mr-1"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>
                                  4.8
                                </div>
                              </div>
                            </div>
                            <div className="p-5">
                              <h4 className="font-bold text-lg text-gray-900 mb-3">
                                New Year's Eve Party
                              </h4>
                              <div className="space-y-2 text-sm text-gray-600">
                                <div className="flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-calendar w-3 h-3 text-primary"
                                  >
                                    <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                                    <line x1={16} x2={16} y1={2} y2={6} />
                                    <line x1={8} x2={8} y1={2} y2={6} />
                                    <line x1={3} x2={21} y1={10} y2={10} />
                                  </svg>
                                  <span>Dec 31, 2024</span>
                                </div>
                                <div className="flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-map-pin w-3 h-3 text-primary"
                                  >
                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                    <circle cx={12} cy={10} r={3} />
                                  </svg>
                                  <span>Rooftop Bar</span>
                                </div>
                                <div className="flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-users w-3 h-3 text-primary"
                                  >
                                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                    <circle cx={9} cy={7} r={4} />
                                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                  </svg>
                                  <span>20 attended</span>
                                </div>
                              </div>
                              <div className="flex gap-2 mt-4">
                                <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md px-3 flex-1 border-primary/30 text-primary hover:bg-primary/10 bg-transparent">
                                  View Photos
                                </button>
                                <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md px-3 border-gray-300 text-gray-600 hover:bg-gray-50 bg-transparent">
                                  Review
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                )}

                {activeTab === "settings" && (
                  <div>
                        <div>
                          <h2 className="text-lg font-bold text-gray-900">Account Settings</h2>
                          <p className="text-sm text-gray-600 mt-1">
                            Manage your account preferences and privacy settings
                          </p>
                        </div>


                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                          <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                            <div className="flex flex-col space-y-1.5 p-6 pb-4">
                              <h3 className="font-semibold tracking-tight flex items-center gap-2 text-base">
                                <div className="p-1.5 bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-user w-4 h-4 text-primary"
                                  >
                                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                                    <circle cx={12} cy={7} r={4} />
                                  </svg>
                                </div>
                                Profile Information
                              </h3>
                              <p className="text-sm text-gray-600">
                                Update your personal information and profile details
                              </p>
                            </div>
                            <div className="p-6 pt-0 space-y-4 px-6 pb-8">
                              <div className="space-y-2">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="name"
                                >
                                  Full Name
                                </label>
                                <input
                                  className="flex h-10 w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 text-sm"
                                  id="name"
                                  type="text"
                                  defaultValue="Sarah Chen"
                                />
                              </div>
                              <div className="space-y-2">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="email"
                                >
                                  Email
                                </label>
                                <input
                                  className="flex h-10 w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 text-sm"
                                  id="email"
                                  type="email"
                                  defaultValue="sarah.chen@email.com"
                                />
                              </div>
                              <div className="space-y-2">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="phone"
                                >
                                  Phone
                                </label>
                                <input
                                  className="flex h-10 w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 text-sm"
                                  id="phone"
                                  type="text"
                                  defaultValue="+1 (555) 123-4567"
                                />
                              </div>
                              <div className="space-y-2">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="location"
                                >
                                  Location
                                </label>
                                <input
                                  className="flex h-10 w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 text-sm"
                                  id="location"
                                  type="text"
                                  defaultValue="San Francisco, CA"
                                />
                              </div>
                              <div className="space-y-2">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="bio"
                                >
                                  Bio
                                </label>
                                <textarea
                                  className="flex w-full rounded-md border bg-background px-3 py-2 ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 min-h-[80px] text-sm"
                                  id="bio"
                                  defaultValue={
                                    "Adventure seeker and culture enthusiast. Love discovering hidden gems and sharing travel stories with fellow wanderers."
                                  }
                                />
                              </div>
                              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-sm mt-6">
                                Save Changes
                              </button>
                            </div>
                          </div>
                          <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                            <div className="flex flex-col space-y-1.5 p-6 pb-3">
                              <h3 className="font-semibold tracking-tight flex items-center gap-2 text-base">
                                <div className="p-1.5 bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-lock w-4 h-4 text-primary"
                                  >
                                    <rect width={18} height={11} x={3} y={11} rx={2} ry={2} />
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                  </svg>
                                </div>
                                Security
                              </h3>
                              <p className="text-sm text-gray-600">
                                Manage your password and security preferences
                              </p>
                            </div>
                            <div className="p-6 pt-0 space-y-3">
                              <div className="space-y-1">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="current-password"
                                >
                                  Current Password
                                </label>
                                <div className="relative">
                                  <input
                                    className="flex h-10 w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 pr-10 text-sm"
                                    id="current-password"
                                    placeholder="Enter current password"
                                    type="password"
                                  />
                                  <button
                                    className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:text-accent-foreground rounded-md absolute right-0 top-0 h-full px-2 py-2 hover:bg-transparent"
                                    type="button"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-eye h-3.5 w-3.5 text-gray-400"
                                    >
                                      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </button>
                                </div>
                              </div>
                              <div className="space-y-1">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="new-password"
                                >
                                  New Password
                                </label>
                                <div className="relative">
                                  <input
                                    className="flex h-10 w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 pr-10 text-sm"
                                    id="new-password"
                                    placeholder="Enter new password"
                                    type="password"
                                  />
                                </div>
                              </div>
                              <div className="space-y-1">
                                <label
                                  className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
                                  htmlFor="confirm-password"
                                >
                                  Confirm Password
                                </label>
                                <div className="relative">
                                  <input
                                    className="flex h-10 w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 focus:border-primary/50 focus:ring-primary/20 pr-10 text-sm"
                                    id="confirm-password"
                                    placeholder="Confirm new password"
                                    type="password"
                                  />
                                </div>
                              </div>
                              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-sm">
                                Update Password
                              </button>
                            </div>
                          </div>
                          <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                            <div className="flex flex-col space-y-1.5 p-6 pb-3">
                              <h3 className="font-semibold tracking-tight flex items-center gap-2 text-base">
                                <div className="p-1.5 bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-bell w-4 h-4 text-primary"
                                  >
                                    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
                                    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
                                  </svg>
                                </div>
                                Notifications
                              </h3>
                              <p className="text-sm text-gray-600">
                                Choose what notifications you want to receive
                              </p>
                            </div>
                            <div className="p-6 pt-0 space-y-3">
                              <ToggleRow
                                  title="Email Notifications"
                                  desc="Receive updates via email"
                                  value={toggles.email}
                                  onToggle={() => toggleSwitch(setToggles, "email")}
                                />
                                <ToggleRow
                                  title="Push Notifications"
                                  desc="Receive push notifications"
                                  value={toggles.push}
                                  onToggle={() => toggleSwitch(setToggles, "push")}
                                />
                                <ToggleRow
                                  title="SMS Notifications"
                                  desc="Receive text messages"
                                  value={toggles.sms}
                                  onToggle={() => toggleSwitch(setToggles, "sms")}
                                />
                                <ToggleRow
                                  title="Marketing Emails"
                                  desc="Receive promotional content"
                                  value={toggles.marketing}
                                  onToggle={() => toggleSwitch(setToggles, "marketing")}
                                />
                            </div>
                          </div>
                          <div className="rounded-lg text-card-foreground bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                            <div className="flex flex-col space-y-1.5 p-6 pb-3">
                              <h3 className="font-semibold tracking-tight flex items-center gap-2 text-base">
                                <div className="p-1.5 bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-shield w-4 h-4 text-primary"
                                  >
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                                  </svg>
                                </div>
                                Privacy
                              </h3>
                              <p className="text-sm text-gray-600">
                                Control who can see your information
                              </p>
                            </div>
                            <div className="p-6 pt-0 space-y-3">
                              <ToggleRow
                                  title="Profile Visible"
                                  desc="Make your profile public"
                                  value={privacy.profileVisible}
                                  onToggle={() => togglePrivacy("profileVisible")}
                                />
                                <ToggleRow
                                  title="Show Email"
                                  desc="Display email on profile"
                                  value={privacy.showEmail}
                                  onToggle={() => togglePrivacy("showEmail")}
                                />
                                <ToggleRow
                                  title="Show Phone"
                                  desc="Display travel history"
                                  value={privacy.showPhone}
                                  onToggle={() => togglePrivacy("showPhone")}
                                />
                            </div>
                          </div>
                        </div>
                  </div>
                )}
              </div>
            </div>
            

</div>

           

            


          
      </main>
      <Footer />
    </>
  );
};

export default Profile;